var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.5091 38.2455C51.5091 52.4748 39.9839 64 25.7545 64C11.5252 64 0 52.4748 0 38.2455C0 34.4467 0.837022 30.841 2.31791 27.5573L6.24547 31.4849C5.53722 33.6097 5.15091 35.8632 5.15091 38.2455C5.15091 49.5775 14.4225 58.8491 25.7545 58.8491C37.0865 58.8491 46.3581 49.5775 46.3581 38.2455C46.3581 35.8632 45.9718 33.6097 45.1992 31.4849L49.1911 27.5573C50.672 30.841 51.5091 34.4467 51.5091 38.2455ZM25.7545 12.4909C21.9557 12.4909 18.3501 13.328 15.0664 14.8089L18.994 18.8008C21.1187 18.0282 23.3722 17.6418 25.7545 17.6418C28.1368 17.6418 30.3903 18.0282 32.5151 18.8008L36.507 14.8089C33.159 13.328 29.5533 12.4909 25.7545 12.4909ZM58.5272 0L25.7545 32.7726L5.73038 12.7485L0.257545 18.2213L20.2817 38.2455L25.7545 43.7183L31.2274 38.2455L64 5.47284L58.5272 0Z",
    fill: "#40CEE4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/Checked.9570e9a2.svg";
export { ForwardRef as ReactComponent };